import { Environments } from '@content-platform/web-angular-shared-util-configuration';
import { Observable } from 'rxjs';

/**
 * NgRx State structure.
 */
export interface EmailState {
  data: any;
}

/**
 * NOTE: This may change in the future if/when the email endpoint is migrated
 * outside of the Global Entry Gateway for general use across apps.
 */
/* export const emailEndpoint$: Observable<string> = Environments.getEnvironment() === 'pr' || Environments.getEnvironment() === 'dev'? 
Environments.getUrlAsync('submissionEndpointNew') : Environments.getUrlAsync('submissionEndpoint');
 */
export const emailEndpoint$: Observable<string> = Environments.getUrlAsync('submissionEndpoint');
/**
 * The base required structure required for sending an email to the GE Gateway `/email` endpoint
 */
export interface EmailResource {
  toAddr: string;
  CC?: string | string[];
  BCC?: string | string[];
  subject: string;
  templateFileName: string;
}

/**
 * Used when creating an invitation for an external user (outside Viacom) and sending them an
 * email to finalize creating their account.
 */
export interface ExternalInvitationEmail extends EmailResource {
  senderName: string;
  invitedUserName: string;
  redeemUrl: string;
}

/**
 * Used when requesting Viacom's support the creation of a new user and its roles
 */
export interface RequestNewUserEmail extends EmailResource {
  requestorUserName: string;
  requestedUserName: string;
  requestedUserEmail: string;
  requestedUserType: string;
  requestedUserRoles: string[];
  requestedClonedUser: string;
}

/**
 *  This data is used to display the email template about the file failure information - GE Specific
 *
 * @export
 * @interface FileIssueReportEmail
 * @extends {EmailResource}
 */
export interface FileIssueReportEmail extends EmailResource {
  submission: FileIssueInfo;
}

export interface FileIssueInfo {
  createdBy: string;
  fileName: string;
  issueDesc: string;
  notes?: string;
}

/**
 * Matches available GE Gateway templates
 */
export const EMAIL_TEMPLATES = {
  globalEntryShare: 'shareEmail',
  globalEntrySubmissionUpdated: 'updateEmail',
  globalEntryFileLevelStatuses: 'fileLevelStatuses',
  administrationInvitedExternalUser: 'inviteExternalUser',
  administrationRequestNewUser: 'requestNewUser',
};

export const HTTP_REQUEST_HEADERS = {
  'Content-Type': 'application/json',
};
